import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Phone } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';
const OPCOES = [
  ['atendeu', 'Atendeu'], ['nao_atende', 'Não atende'], ['ocupado', 'Ocupado'], ['voicemail', 'Voicemail'],
  ['reagendar', 'Reagendar'], ['visita_marcada', 'Visita marcada'], ['sem_interesse', 'Sem interesse'],
];

export const CallOutcomeDialog = ({ lead, onClose, onSaved }) => {
  const [outcome, setOutcome] = useState('');
  const [notes, setNotes] = useState('');
  const [when, setWhen] = useState('');
  const [saving, setSaving] = useState(false);
  useEffect(() => { setOutcome(''); setNotes(''); setWhen(''); }, [lead]);

  const save = async () => {
    if ((outcome === 'reagendar' || outcome === 'visita_marcada') && !when) { toast.error('Escolha data e hora'); return; }
    setSaving(true);
    try {
      const payload = { outcome, method: 'telefone', notes };
      if (when) payload.next_action_at = new Date(when).toISOString();
      await axios.post(`${API_URL}/leads/${lead.id}/contact`, payload);
      toast.success('Chamada registada');
      onSaved?.();
      onClose();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Erro ao registar'); } finally { setSaving(false); }
  };

  return (
    <Dialog open={!!lead} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="call-outcome-dialog" aria-describedby={undefined}>
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Phone className="w-4 h-4 text-emerald-600" />Como correu a chamada?</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-600 -mt-2">{lead?.client_name} · {lead?.client_phone}</p>
        <div className="flex flex-wrap gap-1.5">
          {OPCOES.map(([k, l]) => (
            <button key={k} type="button" onClick={() => setOutcome(k)} data-testid={`call-outcome-${k}`}
              className={`text-sm px-3 py-1.5 rounded-full border transition-colors ${outcome === k ? 'bg-[#2D3E6F] text-white border-[#2D3E6F]' : 'bg-white border-slate-200 text-slate-700 hover:border-[#2D3E6F]'}`}>{l}</button>
          ))}
        </div>
        {(outcome === 'reagendar' || outcome === 'visita_marcada') && (
          <input type="datetime-local" value={when} onChange={(e) => setWhen(e.target.value)} className="border border-slate-300 rounded-md px-2 py-1.5 text-sm" data-testid="call-outcome-when" />
        )}
        <textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={2} maxLength={500} placeholder="Nota (opcional)" className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm" data-testid="call-outcome-notes" />
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose}>Agora não</Button>
          <Button disabled={!outcome || saving} onClick={save} className="bg-emerald-600 hover:bg-emerald-700" data-testid="call-outcome-save">Registar</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
